import { createFileRoute } from '@tanstack/react-router';
import { audiencesList, productionsList, venuesList } from '@/api/resources';
import { warm, warmBackground } from '@/api/loaders';
import { requireCapability } from '@/lib/route-guards';
import { AudiencePlanner } from '@/screens/audience-planner';

export const Route = createFileRoute('/audience-planner')({
  beforeLoad: requireCapability('audiences_view'),
  // The three pickers the planner builds a definition from. The analysis POST
  // itself is user-driven and has nothing to warm.
  loader: ({ context }) => {
    warmBackground(context.queryClient, venuesList({}));
    return warm(context.queryClient, audiencesList({}), productionsList({}));
  },
  component: AudiencePlanner,
});
